import { RouteComponentProps, useLocation } from "@gatsbyjs/reach-router"
import { APAsyncButton, APColumn, APExpanded, APImage, APRow, APSizedBox, APText, getIt, showErrorDialog } from "ap-components"
import { Note } from "."
import { AutoPaySetup } from "./AutoPayInstruction"
import MandateScrollContainer from "./MandateScrollContainer"
import SharedPrefs from "../../Services/SharedPrefs"

const BENEFITS = [
    {
        image: "safe",
        desc: "High safety & low risk"
    },
    {
        image: "online_process",
        desc: "A-Z online process"

    },
    {
        image: "predictable",
        desc: "Fixed & predictable returns"

    },
    {
        image: "market",
        desc: "Independent of market volatility"
    }
]

export default function CancelSetup(props: RouteComponentProps<{ mandateId: string }>) {
    var location = useLocation();

    // Error message from the webhook redirection
    const searchParams = new URLSearchParams(location.search);
    const message = searchParams.get("msg");
    const token = searchParams.get("tkn");
    if (token) {
        getIt(SharedPrefs).setItem("mandateTkn", token);
    }

    return (
        <MandateScrollContainer
            scrollContent={
                <APColumn gap="8px">
                    <AutoPaySetup />
                    <APRow gap="10px" style={{ background: "#ffe8e7", borderRadius: "8px", padding: "8px 10px" }}>
                        <APImage src={"/img/ic_failed.svg"} />
                        <APExpanded>
                            <APText style={{ color: "#bc0a00", fontSize: "14px", lineHeight: 1.43 }}>
                                Auto pay setup failed. Error: {message || "Unknown Error"}
                            </APText>
                        </APExpanded>
                    </APRow>
                </APColumn>
            }

            actions={
                <APColumn crossAxisAlignment="stretch">
                    <Note text={"Join 1 lakh+ users in opting to AutoPay."} />
                    <APSizedBox height="24px" />
                    <APAsyncButton
                        onClick={async () => {
                            if (!props.mandateId) {
                                showErrorDialog("Couldn't proceed further, please contact support team.")
                                return
                            }
                            window.location.href = `/mandate/${props.mandateId}/review`
                        }}
                    >
                        Continue
                    </APAsyncButton>
                </APColumn>
            }
        />
    )
}